import { gql } from '@provision/graphql-client';

export const WORKFLOW_FIELDS = gql`
  fragment WorkflowFields on Workflow {
    id
    workflowId
    partnerId
    name
    description
    createdAt
    updatedAt
  }
`;

export const WORKFLOW_VERSION_FIELDS = gql`
  fragment WorkflowVersionFields on WorkflowVersion {
    id
    workflowVersionId
    workflowId
    partnerId
    version
    isActive
    definition
    description
    createdAt
    updatedAt
    deletedAt
  }
`;

export const WORKFLOW_ASSIGNMENT_FIELDS = gql`
  fragment WorkflowAssignmentFields on WorkflowAssignment {
    id
    workflowAssignmentId
    partnerId
    workflowId
    workflowPartnerId
    triggerType
  }
`;

/** A step field's own facts; nesting is selected by the query, since fragments can't recurse. */
export const WORKFLOW_STEP_FIELD_FIELDS = gql`
  fragment WorkflowStepFieldFields on WorkflowStepField {
    key
    label
    kind
    required
    requiredUnless {
      key
      oneOf
    }
    description
    options {
      value
      label
    }
    valueTypes
    defaultOn
    allowedStepTypes
    reference {
      stepTypes
      outputPath
    }
  }
`;
